import React, {Component} from 'react';
import {Button, Col, ControlLabel, FormControl, Row} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
import {prepareSelectOptionsList} from 'util/Utils';
import Select from 'react-select'
import config from '../../../config';
import _ from 'lodash';
import {ADD_SELECTED_TRANSACTIONS, CLEAR_SELECTED_TRANSACTIONS} from "actions/actionTypes";


export default class AdminTransactionSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        // var SellerID ={ }
        //   if (this.props.adminTransactions.fetched && this.props.adminTransactions.SellerID && this.props.adminTransactions.total >0) {
        //     SellerID =  {value:  this.props.adminTransactions.data[0].SellerID._id,  label:this.props.adminTransactions.data[0].SellerID.DisplayName}
        // } else{
        //      SellerID =  {value: 'all', label: 'All'}
        //  }
        var Statuses =  _.isUndefined(this.props.location.query.Statuses) ? [ {value: 'Sold', label: 'Sold'}] : _.isArray(this.props.location.query.Statuses) ? _.map(this.props.location.query.Statuses, function (status) {

            return _.find(config.transactionStatusMap, {value:status})
        }) : [_.find(config.transactionStatusMap, {value:this.props.location.query.Statuses})]
        var Types =  _.isUndefined(this.props.location.query.Types) ? [
          //  {value: 'Sale', label: 'Sale'}
            ] : _.isArray(this.props.location.query.Types) ? _.map(this.props.location.query.Types, function (item) {

            return _.find(config.transactionTypesMap, {value:item})
        }) : [_.find(config.transactionTypesMap, {value:this.props.location.query.Types})]
        Types = _.compact(Types)
        Statuses = _.compact(Statuses)
        if (_.size(_.get(this.props.location.query, 'recordIDs', []))  ){
            Statuses = []
            Types=[]
        }
        var filterOptions = {
            perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
            TransactionNumber: _.isUndefined(this.props.location.query.TransactionNumber) ? '' : this.props.location.query.TransactionNumber,
            SellerID: _.isUndefined(this.props.location.query.SellerID) ? null : this.props.location.query.SellerID,
            Statuses: Statuses,
            Types:Types,
            fromFD:_.isUndefined(this.props.location.query.fromFD) ? '' : moment(this.props.location.query.fromFD),
            toFD:_.isUndefined(this.props.location.query.toFD) ? '' : moment(this.props.location.query.toFD),
            fromSD:_.isUndefined(this.props.location.query.fromSD) ? '' : moment(this.props.location.query.fromSD),
            toSD:_.isUndefined(this.props.location.query.toSD) ? '' : moment(this.props.location.query.toSD),
            fromPD:_.isUndefined(this.props.location.query.fromPD) ? '' : moment(this.props.location.query.fromPD),
            toPD:_.isUndefined(this.props.location.query.toPD) ? '' : moment(this.props.location.query.toPD),
            OrderNumber:_.isUndefined(this.props.location.query.OrderNumber) ? '' : this.props.location.query.OrderNumber,
            ScannedLPN: _.isUndefined(this.props.location.query.ScannedLPN) ? '' : this.props.location.query.ScannedLPN,
            PaymentMethod: _.isUndefined(this.props.location.query.PaymentMethod) ? '' : this.props.location.query.PaymentMethod,
            inventory:  _.isUndefined(this.props.location.query.inventory) ?  [] : _.isArray(this.props.location.query.inventory) ? _.map(this.props.location.query.inventory, function (value) {
                return _.find(config.inventoryOwnershipMap, {value:value})
            }) : [_.find(config.inventoryOwnershipMap, {value:this.props.location.query.inventory})],
            Deleted: _.isUndefined(this.props.location.query.Deleted) ? 'false' : this.props.location.query.Deleted,
            advancedOptionsVisible: false,
            searchText:  _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
            Markets:_.isUndefined(this.props.location.query.Markets) ? [] : _.map(this.props.location.query.Markets.split(','), function (item) {
                var location = _.find(config.warehouseData, function (o) {
                    return o.MarketName == item
                });
                if (location) {
                    return {'value': item, 'label': location.MarketName}
                }
            }),
            recordIDs:  _.isUndefined(this.props.location.query.recordIDs) ?  [] : _.isArray(this.props.location.query.recordIDs) ?  _.get(this.props.location.query, 'recordIDs', []) : [_.get(this.props.location.query, 'recordIDs')]


            //   fromCreateTimeDisplay: _.isUndefined(this.props.location.query.from) ? '' : moment(this.props.location.query.from).format("MM-DD-YYYY"),
            //   toCreateTimeDisplay: _.isUndefined(this.props.location.query.to) ? '' : moment(this.props.location.query.to).format("MM-DD-YYYY"),
        }
        // if(_.size(_.get(filterOptions,'recordIDs',[]))>0 ){
        //     delete filterOptions.perPage
        // }
         this.state = {
            filterOptions: filterOptions
        };

        this.allSellersOptionsList =  prepareSelectOptionsList(this.props.allSellersList.data, {
            label: 'DisplayName',
            value: '_id'
        })

    };

    componentWillReceiveProps(nextProps) {


    }


    setSearchParams(params) {
         if ( params.SellerID !== this.state.filterOptions.SellerID){
            this.props.fetchSelectedUserData(params.SellerID)
        }
        this.setState({filterOptions: {...this.state.filterOptions, ...params}});
    }

    resetSearchParams() {
        this.setState({
            filterOptions: {
                perPage:   config.table.numberPerPage,
                TransactionNumber: '',
                Statuses: [ {value: 'Sold', label: 'Sold'}],
                fromFD: '',
                toFD: '',
                toSD:'',
                fromSD:'',
                fromPD: '',
                toPD: '',
                SellerID: null,
                PaymentMethod:null,
                Deleted:'false',
                ScannedLPN: '',
            }
        }, function () {

            this.props.resetSearch();
        });

    }




    onMarketsSelect(options) {
        var updateOptions = {...this.state.filterOptions, Markets: options};
        this.setState({'filterOptions': updateOptions}, function () {
         //   this.props.search();
        });
    }
    getSearchParams(filtersChanged = {}) {
        var filterOptions = {...this.state.filterOptions, ...filtersChanged};

        var queryParams =  {

        }
        if (!_.isUndefined(filterOptions.Types)) {
            queryParams.Types = _.map(filterOptions.Types, 'value')
        }else{
            queryParams.Types =[ "Sale", "PickupFee", "Fee", "Credit"]
        }
        if (!_.isUndefined(filterOptions.Statuses)) {
            queryParams.Statuses = _.map(filterOptions.Statuses, 'value')
        }
        if (filterOptions.PaymentMethod) {
            queryParams.PaymentMethod = filterOptions.PaymentMethod;
        }
        if (filterOptions.SellerID) {
            queryParams.SellerID = filterOptions.SellerID;
        }
        if (_.get(filterOptions,'Deleted', '') =='true') {
            queryParams.Deleted = filterOptions.Deleted;
        }
        if (filterOptions.OrderNumber) {
            queryParams.OrderNumber = filterOptions.OrderNumber;
        }
        if (filterOptions.ScannedLPN && filterOptions.ScannedLPN.trim()) {
            queryParams.ScannedLPN = filterOptions.ScannedLPN.trim();
        }
        if (filterOptions.searchText) {
            queryParams.searchText = filterOptions.searchText;
        }
        if (_.size(filterOptions.Markets) > 0) {
            queryParams.Markets = _.map(filterOptions.Markets, 'value').join(',')
        }
        if ( filterOptions.inventory) {
            queryParams.inventory = _.map(filterOptions.inventory, 'value')
        }

            queryParams.perPage = filterOptions.perPage;

        if (filterOptions.fromFD &&  moment(filterOptions.fromFD, 'MM-DD-YYYY HH:mm',true).isValid() ) {
            queryParams.fromFD = filterOptions.fromFD.toISOString()
        }
         if (filterOptions.toFD &&  moment(filterOptions.toFD, 'MM-DD-YYYY HH:mm',true).isValid()  ) {
            queryParams.toFD = filterOptions.toFD.toISOString()
        }
        if (filterOptions.fromSD &&  moment(filterOptions.fromSD, 'MM-DD-YYYY HH:mm',true).isValid() ) {
            queryParams.fromSD = filterOptions.fromSD.toISOString()
        }
        if (filterOptions.toSD &&  moment(filterOptions.toSD, 'MM-DD-YYYY HH:mm',true).isValid()  ) {
            queryParams.toSD = filterOptions.toSD.toISOString()
        }
        if (filterOptions.fromPD &&  moment(filterOptions.fromPD, 'MM-DD-YYYY HH:mm',true).isValid() ) {
            queryParams.fromPD = filterOptions.fromPD.toISOString()
        }
        if (filterOptions.toPD &&  moment(filterOptions.toPD, 'MM-DD-YYYY HH:mm',true).isValid()  ) {
            queryParams.toPD = filterOptions.toPD.toISOString()
        }
        if (_.size(filterOptions.recordIDs) > 0) {
            queryParams.recordIDs = filterOptions.recordIDs
            queryParams.all= true;
        }

        return {queryParams}
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }


    onSelectAllRecordsChange() {
        var self = this;
        if (self.props.adminTransactions.selectedTransactions.length == 0) {

            this.props.search({include: ['_id'], all: true}).then(response => {
                this.props.toggleAllRecordsSelection(true)
                let matchingRecordsNumber= response.data.data.length; 
                let transactionsToSelect = response.data.data;

                if(self.props.matchingFeeTransactions.fetched){
                    matchingRecordsNumber += self.props.matchingFeeTransactions.total
                    transactionsToSelect =transactionsToSelect.concat(self.props.matchingFeeTransactions.data)
                }

                if (matchingRecordsNumber !== self.props.adminTransactions.total){
                   return this.props.displayMessage({
                        'messageType': 'warning',
                        'messageCode': 'Number of selected transactions do not match the total number of matching transactions. Please, press Search button and try again'
                    });
                }

                self.props.dispatchAction(transactionsToSelect, ADD_SELECTED_TRANSACTIONS)
            });
        } else {
            this.props.toggleAllRecordsSelection(false);

            this.props.dispatchAction({}, CLEAR_SELECTED_TRANSACTIONS)
        }
    }

    // displayFoundSellersDisplayNames(){
    //      return _.map(this.props.foundSellersList, function (record) {
    //         return (<span key={record.value} onClick={(e)=>this.props.search({'SellerID':record.value})} className="seller-select-button">{record.label}</span>);
    //     }.bind(this))
    // }
    render() {
        let displayCustomOptionsForPayout =(this.props.allowGeneratePayout && this.state.filterOptions.SellerID && this.state.filterOptions.Types.length ==1 && this.state.filterOptions.Types[0].value =='Sale' )

        const {amountToPay =''} = this.state.filterOptions

        var self = this;
         return (
            <div className="transaction-search-block bot15">

                <Row className="top10">

                    <Col xs={9} sm={4} md={4} lg={3} className=" top10">
                         <Select
                            tabIndex="0"
                            searchable={true}
                            selectedOptions
                            clearable={true}
                            placeholder="Seller"
                            options={this.props.sellersOptionsList}
                            // options={ this.props.foundSellersList }
                            onChange={ (selectedOption) => {
                                console.log('selectedOption',selectedOption );
                                this.props.fetchSelectedUserData(selectedOption ?  selectedOption.value : null)

                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        SellerID:  selectedOption ?  selectedOption.value : null,
                                    }
                                }, function () {
                                  //  this.props.search();
                                })
                            }}
                             value={this.state.filterOptions.SellerID}
                        />

                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                         <Select
                            tabIndex="0"
                          placeholder="Payment Type"
                            clearable={true}
                            options={ _.map(_.omit(config.payoutMethodsMap,  ['DirectDeposit']), function (key, value) {
                                return {value: value, label: key}
                            })}
                            onChange={ (selectedOption)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        PaymentMethod: selectedOption ? selectedOption.value : null
                                    }
                                }, function () {
                                  //  this.props.search();
                                });
                            }
                            }
                            value={self.state.filterOptions.PaymentMethod}
                        />
                    </Col>
                    <Col xs={9}  sm={4}  md={4} lg={3}   className="top10">
                        <Select
                            tabIndex="0"
                            multi
                            placeholder="Type"
                            clearable={true}
                            options={_.reject(config.transactionTypesMap,{value:'PayBonus'})}
                            onChange={(selectedOptions)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Types: selectedOptions
                                    }
                                }, function () {
                                    //  this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.Types}
                        />
                    </Col>
                    <Col xs={9}  sm={4}  md={4} lg={3}   className="top10">
                        <Select
                            tabIndex="0"
                            multi
                            placeholder="Payment Status"
                            clearable={true}
                            options={config.transactionStatusMap}
                            onChange={(selectedOptions)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Statuses: selectedOptions
                                    }
                                }, function () {
                                  //  this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.Statuses}
                        />
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={(event) => {
                                         this.setState({
                                             'filterOptions': {
                                                 ...this.state.filterOptions,
                                                 searchText: event.target.value
                                             }
                                         })
                                     }}
                             placeholder="Search"
                        />
                    </Col>
                </Row>
                <Row className="top15">

                    <Col xs={9} sm={4} md={4} lg={3} className=" ">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              fromFD: option,
                                          }
                                      }, function () {
                                       //   this.props.search();
                                      });
                                  }}
                                  value={this.state.filterOptions.fromFD}
                            inputProps={{placeholder: 'From Fulfillment Date'}}
                        />
                    </Col>
                    <Col xs={9}  sm={4}  md={4} lg={3}  className=" ">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              toFD: option,
                                          }
                                      }, function () {
                                       //   this.props.search();
                                      });
                                  }}
                                  inputProps={{placeholder: 'To Fulfillment Date'}}
                                  value={this.state.filterOptions.toFD}

                        />
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className=" ">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              fromPD: option,
                                          }
                                      }, function () {
                                       //   this.props.search();
                                      });
                                  }}
                                  inputProps={{placeholder: 'From Paid Date'}}
                                  value={this.state.filterOptions.fromPD}
                         />
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className=" ">

                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              toPD: option,
                                          }
                                      }, function () {
                                       //   this.props.search();
                                      });
                                  }}
                                  inputProps={{placeholder: 'To Paid Date'}}
                                  value={this.state.filterOptions.toPD}
                        />
                    </Col>
                    </Row>
                <Row className="top15">

                    <Col xs={9} sm={4} md={4} lg={3} className=" ">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              fromSD: option,
                                          }
                                      }, function () {
                                        //  this.props.search();
                                      });
                                  }}
                                  value={this.state.filterOptions.fromSD}
                                  inputProps={{placeholder: 'From Sold Date'}}
                        />
                    </Col>
                    <Col xs={9}  sm={4}  md={4} lg={3}  className=" ">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              toSD: option,
                                          }
                                      }, function () {
                                        //  this.props.search();
                                      });
                                  }}
                                  inputProps={{placeholder: 'To Sold Date'}}
                                  value={this.state.filterOptions.toSD}

                        />
                    </Col>
                </Row>
                    <Row className="top15">
                        <Col xs={9} sm={4} md={4} lg={3} className=" ">
                             <FormControl type="text"
                                         defaultValue={this.state.filterOptions.OrderNumber}
                                         onKeyPress={this._handleKeyPress.bind(this)}
                                         onChange={(event) => {
                                             this.setState({
                                                 'filterOptions': {
                                                     ...this.state.filterOptions,
                                                     OrderNumber: event.target.value
                                                 }
                                             })
                                         }}
                                 placeholder="Order number"
                            />
                        </Col>
                        <Col xs={9} sm={4} md={4} lg={3} className=" ">
                             <FormControl type="text"
                                         defaultValue={this.state.filterOptions.ScannedLPN}
                                         autoComplete="off"
                                         onKeyPress={this._handleKeyPress.bind(this)}
                                         onChange={(event) => {
                                             this.setState({
                                                 'filterOptions': {
                                                     ...this.state.filterOptions,
                                                     ScannedLPN: event.target.value
                                                 }
                                             })
                                         }}
                                 placeholder="Scannable Partner LPN"
                            />
                        </Col>
                        <Col xs={9} sm={4} md={4} lg={3} className=" ">
                             <Select
                                tabIndex="0"
                                placeholder="Inventory Owner"
                                clearable={true}
                                multi
                                options={config.inventoryOwnershipMap}
                                onChange={(selectedOptions) => {
                                     this.setState({'filterOptions': {...this.state.filterOptions, inventory: selectedOptions}}, function () {
                                       // self.props.search({page: 1})
                                    });
                                }}
                                 value={self.state.filterOptions.inventory}
                            />
                        </Col>
                        <Col xs={9} sm={4} md={4} lg={3} className=" ">
                             <Select
                                tabIndex="0"
                                multi
                                clearable={false}
                                placeholder="Location"
                                options={   _.map(config.warehouseData, item => {
                                    return {value: item.MarketName, label: item.MarketName}
                                })}
                                onChange={this.onMarketsSelect.bind(this)}
                                value={self.state.filterOptions.Markets}
                            />
                        </Col>
                </Row>
                <Row className="top15">
                    <Col xs={12} sm={6} md={3} lg={3} className="pbot10">
                        <Button className="btn btn-primary pull-left" disabled={this.props.pending} onClick={(event) => self.props.search({})}
                                type="button">
                            SEARCH
                        </Button>
                        <button className="pull-right  btn btn-primary  left20 pull-left"
                                onClick={(event) => this.resetSearchParams()}
                                type="button">
                            RESET
                        </button>
                    </Col>
                </Row>
                {this.state.advancedOptionsVisible &&
                <Row className="">
                    {this.props.adminTransactions.fetched && this.props.adminTransactions.total > 0   &&
                    <div className="left15  top20 pull-left right20">
                        <Button className="btn btn-primary top16" onClick={this.onSelectAllRecordsChange.bind(this)}>
                            {this.props.adminTransactions.selectedTransactions.length == 0 ? 'Select all' : 'Clear selection' }
                        </Button>
                    </div>

                    }
                    <Col xs={6} sm={4} md={3} lg={2} className=" top10">
                        <ControlLabel>Deleted</ControlLabel>
                        <Select
                            tabIndex="0"
                            clearable={true}
                            placeholder=""
                            options={[
                                {value: 'true', label: 'Deleted'},
                                // {value: 'false', label: 'Active'}
                                ]}
                            onChange={(option) => {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Deleted:option ?  option.value : false,
                                    }
                                }, function () {
                                  //  this.props.search();
                                });
                            }}
                             value={self.state.filterOptions.Deleted}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={3} lg={2} className="top10">
                        <ControlLabel>Per Page</ControlLabel>
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={_.reject(config.perPageSelectOptions, {value:'all'})}
                            onChange={(option)=>{ this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
                              //  this.props.search();
                            })}}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>
                  {displayCustomOptionsForPayout &&
                    <Row className="left0">
                      <Col className="top18" xs={12}>
                        <Button className="btn btn-primary"
                                disabled={this.props.matchingFeeTransactions.fetched || this.state.pending}
                                onClick={() => {
                                  this.setState({pending: true})
                                  self.props.toggleAllRecordsSelection(false);
                                  self.props.dispatchAction({}, CLEAR_SELECTED_TRANSACTIONS)
                                  this.props.searchFeeTransactions().then(() => {
                                    self.onSelectAllRecordsChange()
                                    this.setState({pending: false})
                                  }).catch(err => {
                                    this.setState({pending: false})
                                  })
                                }}>
                          {this.props.matchingFeeTransactions.fetched ? this.props.matchingFeeTransactions.total + ' fees added and selected' : 'Add fees to sale transactions'}
                        </Button>
                      </Col>
                      <Col className="top18" xs={12}>
                        <FormControl type="text" className="pull-left"
                                     style={{width: 150}}
                                     onChange={(event) => {
                                       this.setState({
                                         'filterOptions': {
                                           ...this.state.filterOptions,
                                           amountToPay: event.target.value
                                         }
                                       })
                                     }}
                                     placeholder="Amount to pay"
                        />
                        <Button className="btn btn-primary pull-left left15"
                                disabled={amountToPay == '' || isNaN(amountToPay)}
                                onClick={() => {
                                  self.props.toggleAllRecordsSelection(false);
                                  self.props.dispatchAction({}, CLEAR_SELECTED_TRANSACTIONS)
                                  self.props.prepareTransactionsForPayment(amountToPay)
                                }}>
                          {'Apply'}
                        </Button>
                      </Col>
                    </Row>
                  }
                </Row>}
                <Row className="top20">
                    <Col md={4} xs={4} className="top10">
                        <Button className="btn btn-primary"
                                onClick={ () => this.setState({advancedOptionsVisible: !this.state.advancedOptionsVisible})}>
                            Advanced Options
                        </Button>
                    </Col>
                </Row>


            </div>
        );
    }
}



